export default __webpack_public_path__ + "static/media/no-client.9e0e71cb.svg";